import { FeatureIcon, FeatureIconSkeleton } from '@rossum/ui';
import { Badge, Stack, Tooltip } from '@rossum/ui/material';
import { TileIconProps } from './types';

export const TileIcon = (props: TileIconProps) => {
  if ('skeleton' in props) {
    return <FeatureIconSkeleton size="medium" />;
  }

  const { content, size = 'small', color, tooltip, error } = props;

  const featureIcon = (
    <FeatureIcon content={content} size={size} color={color} />
  );

  const iconWithBadge = error ? (
    <Badge color="error" variant="dot">
      {featureIcon}
    </Badge>
  ) : (
    featureIcon
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        <Stack display="inline-flex">{iconWithBadge}</Stack>
      </Tooltip>
    );
  }

  return iconWithBadge;
};
